import { QueryClient } from "@tanstack/react-query";

/** 应用级 React Query 配置：与页面/服务层分离，便于统一调整缓存与重试策略 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
